import { Timeframes as TIME_FRAME } from '../../../../../../../shared/constants';

export const VIEW_MODE = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  CUSTOM: 'custom',
} as const;

export const TIME_FRAME_VIEW_MODE_DICT = {
  [TIME_FRAME.SINGLEDAY]: VIEW_MODE.DAY,
  [TIME_FRAME.MULTIDAY_WEEK]: VIEW_MODE.WEEK,
  [TIME_FRAME.MULTIDAY_MONTH]: VIEW_MODE.MONTH,
  [TIME_FRAME.MULTIDAY]: VIEW_MODE.CUSTOM,
  [VIEW_MODE.DAY]: TIME_FRAME.SINGLEDAY,
  [VIEW_MODE.WEEK]: TIME_FRAME.MULTIDAY_WEEK,
  [VIEW_MODE.MONTH]: TIME_FRAME.MULTIDAY_MONTH,
  [VIEW_MODE.CUSTOM]: TIME_FRAME.MULTIDAY,
} as const;
